import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';
import ToastService from '../services/toastService';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const auth = authService.isAuthenticated();
      setIsAuthenticated(auth);
      
      if (!auth && location.pathname !== '/login') {
        ToastService.error('Session expired. Please login again.');
      }
    };
    
    checkAuth();
    
    // Check authentication every minute
    const interval = setInterval(checkAuth, 60000);
    
    return () => clearInterval(interval);
  }, [location]);

  if (isAuthenticated === null) {
    // Show loading state
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#1E3A8A'
      }}>
        <div style={{ color: 'white', fontSize: '18px' }}>Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;